import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import SEO from '../components/SEO';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="bg-[#081428] text-white min-h-screen">
      <SEO
        title="Página não encontrada - 404"
        description="A página que você está procurando não existe ou foi movida."
        url="/404"
        noindex={true}
        nofollow={true}
      />
      <Navbar />
      <div className="container mx-auto px-4 py-20 flex flex-col items-center justify-center min-h-[70vh]">
        <h1 className="text-6xl font-bold mb-6">404</h1>
        <h2 className="text-3xl font-semibold mb-4">Página não encontrada</h2>
        <p className="text-xl mb-8 text-center max-w-2xl">
          Desculpe, a página que você está procurando não existe ou foi movida.
        </p>
        <button
          onClick={() => navigate('/')}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition duration-300"
        >
          Voltar para a página inicial
        </button>
      </div>
      <Footer />
    </div>
  );
} 